var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//region import

// models
import model from '../base.model';
import { loginModel } from '../auth/login.model';

// constants
import urls from '../../constants/urls.constant';

// storage
import { getServerUrl as settingsGetServerUrl } from '../../device/settings.storage';

// utils

//endregion


class homeModel extends model {
    //region init

    constructor(props) {
        super(props);
    }

    static create() {
        return _extends({}, super.create(), {
            homeStatus: {
                isLoading: false
            },
            setHomeStatus: {
                isLoading: false
            }
        });
    }

    //endregion
    //region model

    static processServerResponse(dispatch, params, model, serverResponse, history) {}

    static isClientEmpty(clientModel) {
        return !clientModel;
    }

    static getReduceMethod(model, type) {
        const reduceMethod = super.getReduceMethod(model, type);
        if (reduceMethod) {
            return reduceMethod;
        }
        const reducers = {
            [model.TYPE_REQUEST_HOME_STATUS]: model.reduceRequestHomeStatus.bind(model),
            [model.TYPE_GET_HOME_STATUS]: model.reduceGetHomeStatus.bind(model),

            [model.TYPE_REQUEST_SET_HOME_STATUS]: model.reduceRequestSetHomeStatus.bind(model),
            [model.TYPE_SET_HOME_STATUS]: model.reduceSetHomeStatus.bind(model)
        };

        return reducers[type];
    }

    //endregion
    //region api get home status

    static apiGetHomeStatus(clientApiMethod, params = {}, dispatch, failAction) {
        var _this = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this.mapHomeStatusToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken, email } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const url = urls.core.getHomeStatus(urlParams);

            dispatch(_this.actionRequestHomeStatus(_this, { modelClient: { isLoading: true }, model: _this }));

            return clientApiMethod(serverUrl, url, serverModel.payload, authToken).then(function (serverResponse) {
                const modelClient = _this.mapHomeStatusToClient(serverResponse, params, email);
                dispatch(_this.actionGetHomeStatus(_this, { modelClient, model: _this }));
            }).catch(function (error) {
                _this.catchRequest(_this, dispatch, failAction)(error);
                dispatch(_this.actionRequestHomeStatus(_this, { modelClient: { isLoading: false }, model: _this }));
            });
        })();
    }

    static actionRequestHomeStatus(model, payload) {
        return {
            type: model.TYPE_REQUEST_HOME_STATUS,
            payload
        };
    }

    static reduceRequestHomeStatus(stateModel, action, state) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                homeStatus: _extends({}, stateModel.homeStatus, {
                    isLoading: modelClient.isLoading
                })
            })
        };
    }

    static actionGetHomeStatus(model, payload) {
        return {
            type: model.TYPE_GET_HOME_STATUS,
            payload
        };
    }

    static mapHomeStatusToClient(serverResponse, params, email) {
        const { homeStatus } = this.create();
        if (!serverResponse) {
            return homeStatus;
        }

        // {"users": [{"name": "uros", "username": "uros@isotel.eu", "status": "Away"}], "status": "All Away", "home_profile": "Auto"}

        const users = serverResponse.users.filter(user => {
            return user.username === email;
        });
        const userName = users && users.length > 0 ? users[0].name.substring(0, 1).toUpperCase() + users[0].name.substring(1) + ', ' : '';

        return {
            homeStatus: {
                users: serverResponse.users,
                status: serverResponse.status,
                homeProfile: serverResponse.home_profile,
                text: userName + serverResponse.status
            }
        };
    }

    static mapHomeStatusToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {
                urlParams: {}
            };
        }

        return {
            urlParams: {}
        };
    }

    static reduceGetHomeStatus(stateModel, action) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, modelClient)
        };
    }

    //endregion
    //region api set home status

    static apiSetHomeStatus(clientApiMethod, params = {}, dispatch, failAction) {
        var _this2 = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this2.mapSetHomeStatusToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const url = urls.core.setHomeStatus(urlParams);

            dispatch(_this2.actionRequestSetHomeStatus(_this2, { modelClient: { isLoading: true }, model: _this2 }));

            return clientApiMethod(serverUrl, url, serverModel.payload, authToken).then(function (serverResponse) {
                const modelClient = _this2.mapSetHomeStatusToClient(serverResponse, params);
                dispatch(_this2.actionSetHomeStatus(_this2, { modelClient, model: _this2 }));
            }).catch(function (error) {
                _this2.catchRequest(_this2, dispatch, failAction)(error);
                dispatch(_this2.actionRequestSetHomeStatus(_this2, { modelClient: { isLoading: false }, model: _this2 }));
            });
        })();
    }

    static actionRequestSetHomeStatus(model, payload) {
        return {
            type: model.TYPE_REQUEST_SET_HOME_STATUS,
            payload
        };
    }

    static reduceRequestSetHomeStatus(stateModel, action, state) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                setHomeStatus: _extends({}, stateModel.setHomeStatus, {
                    isLoading: modelClient.isLoading
                })
            })
        };
    }

    static actionSetHomeStatus(model, payload) {
        return {
            type: model.TYPE_SET_HOME_STATUS,
            payload
        };
    }

    static mapSetHomeStatusToClient(serverResponse, params) {
        const { setHomeStatus } = this.create();
        if (!serverResponse) {
            return setHomeStatus;
        }

        //"{"users":[{"name":"uros","username":"uros@isotel.eu","status":"Away"}],"status":"All Away","home_profile":"Auto"}"

        return {
            setHomeStatus: {}
        };
    }

    static mapSetHomeStatusToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {
                urlParams: {}
            };
        }

        return {
            payload: {
                home_profile: clientModel.status
            },
            urlParams: {}
        };
    }

    static reduceSetHomeStatus(stateModel, action) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, modelClient)
        };
    }
}

homeModel.MODEL_NAME = 'homeModel';
homeModel.TYPE_REQUEST = 'REQUEST_HOME';
homeModel.TYPE_FROM_SERVER = 'GET_HOME';
homeModel.TYPE_CLEAR = 'CLEAR_HOME';
homeModel.TYPE_REQUEST_HOME_STATUS = 'TYPE_REQUEST_HOME_STATUS';
homeModel.TYPE_GET_HOME_STATUS = 'TYPE_GET_HOME_STATUS';
homeModel.TYPE_REQUEST_SET_HOME_STATUS = 'TYPE_REQUEST_SET_HOME_STATUS';
homeModel.TYPE_SET_HOME_STATUS = 'TYPE_SET_HOME_STATUS';
export { homeModel };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/core/home.model.js